/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How event values are aggregated
 * @export
 */
export const LeaderboardAggregationMode = {
    SUM: 'SUM',
    MAX: 'MAX',
    AVERAGE: 'AVERAGE',
    COUNT: 'COUNT'
} as const;
export type LeaderboardAggregationMode = typeof LeaderboardAggregationMode[keyof typeof LeaderboardAggregationMode];


export function instanceOfLeaderboardAggregationMode(value: any): boolean {
    for (const key in LeaderboardAggregationMode) {
        if (Object.prototype.hasOwnProperty.call(LeaderboardAggregationMode, key)) {
            if (LeaderboardAggregationMode[key as keyof typeof LeaderboardAggregationMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LeaderboardAggregationModeFromJSON(json: any): LeaderboardAggregationMode {
    return LeaderboardAggregationModeFromJSONTyped(json, false);
}

export function LeaderboardAggregationModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardAggregationMode {
    return json as LeaderboardAggregationMode;
}

export function LeaderboardAggregationModeToJSON(value?: LeaderboardAggregationMode | null): any {
    return value as any;
}

export function LeaderboardAggregationModeToJSONTyped(value: any, ignoreDiscriminator: boolean): LeaderboardAggregationMode {
    return value as LeaderboardAggregationMode;
}

